import { render, staticRenderFns } from "./chat-message-text.vue?vue&type=template&id=672e579c&scoped=true"
import script from "./chat-message-text.vue?vue&type=script&lang=js"
export * from "./chat-message-text.vue?vue&type=script&lang=js"
import style0 from "./chat-message-text.vue?vue&type=style&index=0&id=672e579c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672e579c",
  null
  
)

export default component.exports